import MessageView from './MessageView.html';

const MessageComponent = {
    template: MessageView,
    controllerAs: '$ctrl',
    bindings: {
        message: '=',
        filter: '&',
    },
};

export default MessageComponent;
